import { logout } from '@platform/core/auth';
import { queryClient } from '@platform/core/state';

export const signout = async () => {
  /**
   * TODO: Remove some time after the migration to the new portal
   *
   * React Query's global persistence setup has been removed.
   * However, it is not cleared automatically from local storage.
   */
  localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE');

  queryClient.clear();
  await logout();
};
